<template>
  <div class="content">
    <div class="content-box">
      <div class="content-top">
        <div>识别记录</div>
        <div class="button" @click="exportSnapPhotoRecordList">导出</div>
      </div>

      <div class="content-main">
        <div class="search">
          <el-date-picker
            v-model="recordQuery.time"
            align="right"
            type="date"
            size="small"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
            :picker-options="pickerOptions"
            @change="findSnapPhotoRecordPage"
          ></el-date-picker>
          <el-select
            size="small"
            v-model="recordQuery.status"
            clearable
            filterable
            placeholder="请选择状态"
            class="select"
            @change="findSnapPhotoRecordPage"
            style="width: 200px; margin: 0 10px 0 18px"
          >
            <el-option
              v-for="item in attendTypes"
              :key="item.id"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-input
            size="small"
            v-model="recordQuery.serialNum"
            placeholder="请输入抓拍机序列"
            style="margin: 0 10px 0 18px"
          ></el-input>
          <el-input
            size="small"
            v-model="recordQuery.personName"
            placeholder="请输入人员姓名"
            style="margin: 0 10px 0 18px"
          ></el-input>
          <div class="button" @click="findSnapPhotoRecordPage">查询</div>
        </div>

        <div class="table">
          <el-table
            stripe
            :data="snapRecordList"
            height="100%"
            :header-cell-style="{ background: '#F5F7F9', color: '#909399' }"
          >
            <el-table-column label="序号" width="100" center>
              <template slot-scope="scope">
                <a style="padding-left: 1vw">{{
                  (recordQuery.pageNum - 1) * recordQuery.pageSize +
                  scope.$index +
                  1
                }}</a>
              </template>
            </el-table-column>
            <el-table-column label="班组" prop="teamsName"></el-table-column>
            <el-table-column label="姓名">
              <template slot-scope="scope">
                {{ scope.row.name || "陌生人" }}
              </template>
            </el-table-column>
            <el-table-column
              label="考勤区域"
              prop="inoutTypeName"
            ></el-table-column>
            <el-table-column
              label="抓拍机序列号"
              prop="serialNum"
            ></el-table-column>
            <el-table-column label="考勤机sn号" prop="imei"></el-table-column>
            <el-table-column label="打卡照片">
              <template slot-scope="scope">
                <el-image
                  style="width: 70px; height: 90px"
                  v-if="scope.row.photoFile != ''"
                  :src="scope.row.photoFile"
                  :preview-src-list="[scope.row.photoFile]"
                ></el-image>
                <div
                  v-else
                  style="
                    width: 70px;
                    height: 90px;
                    background: #ddd;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  暂无图片
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="打卡时间"
              prop="clockTime"
            ></el-table-column>
            <el-table-column label="进出状态">
              <template slot-scope="scope">
                <div v-if="scope.row.teamsName">{{ scope.row.statusName }}</div>
                <div style="color: red" v-else>
                  禁止{{ scope.row.statusName }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  @click="personInfo(scope.$index, scope.row)"
                  >个人详情</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="recordQuery.pageNum"
          :page-sizes="[10,50, 100, 200, 300, 400]"
          :page-size="recordQuery.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="recordTotal"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import base from "../../../untils/base";
import myHttp from "../../../untils/port";
import util from "../../../untils/util";
export default {
  data() {
    return {
      groupId: util.session.get("groupId"),
      attendTypes: [],
      recordQuery: {
        status: "",
        pageNum: 1,
        pageSize: 50,
        time: util.myTime.formatTime(new Date(), "yyyy-MM-dd"),
        personName: "",
        status: "",
        serialNum: "",
        imei: "",
      },
      recordTotal: 0,
      snapRecordList: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
        ],
      },
    };
  },
  created() {
    this.getAttendTypes();
    this.findSnapPhotoRecordPage();
  },
  methods: {
    getAttendTypes() {
      let that = this;
      myHttp
        .getDictByType({
          type: "attend_type",
        })
        .then(function (resp) {
          if (resp.data.code == "200") {
            that.attendTypes = resp.data.data.dictList || [];
          } else {
            that.$message.error(resp.data.msg);
          }
        });
    },
    handleSizeChange(val) {
      this.recordQuery.pageSize = val;
      this.recordQuery.pageNum = 1;
      this.findSnapPhotoRecordPage()
    },
    handleCurrentChange(val) {
      this.recordQuery.pageNum = val;
      this.findSnapPhotoRecordPage()
    },
    findSnapPhotoRecordPage() {
      let that = this;
      this.recordQuery.projectId = this.groupId;
      myHttp.findSnapPhotoRecordPage(this.recordQuery).then(function (resp) {
        console.log(resp);
        if (resp.data.code == "200") {
          that.snapRecordList = resp.data.data.snapPhotoRecordPage.list;
          that.recordTotal = resp.data.data.snapPhotoRecordPage.total;
          if (that.snapRecordList) {
            for (let i = 0; i < that.snapRecordList.length; i++) {
              if (that.snapRecordList[i].facePhoto) {
                that.snapRecordList[i].facePhoto =
                  base.httpCtx + that.snapRecordList[i].facePhoto;
              }
              if (that.snapRecordList[i].photoFile) {
                that.snapRecordList[i].photoFile =
                  base.httpCtx + that.snapRecordList[i].photoFile;
              }
            }
          }
        }
      });
    },
    personInfo(index, row) {
      var port = util.session.get("roleId");
      if (port == "4") {
        this.$router.push({ name: "workerInfo", params: { id: row.personId } });
      } else if (port == "5" || port == "3") {
        this.$router.push({
          name: "workerInfoCom",
          params: { id: row.personId },
        });
      }
    },
    exportSnapPhotoRecordList() {
      var token = util.session.get("token");
      window.open(
        myHttp.exportSnapPhotoRecordList +
          "?projectId=" +
          this.groupId +
          "&personName=" +
          this.recordQuery.personName +
          "&time=" +
          this.recordQuery.time +
          "&imei=" +
          this.recordQuery.imei +
          "&serialNum=" +
          this.recordQuery.serialNum +
          "&status=" +
          this.recordQuery.status +
          "&accessToken=" +
          token
      );
    },
  },
};
</script>

<style scoped>
.content-box {
  height: 100%;
  background: #ffffff;
  box-shadow: 2px 2px 6px 0px rgba(77, 110, 177, 0.2);
  border-radius: 6px;
}

.button {
  display: inline-block;
  width: 52px;
  height: 32px;
  border-radius: 4px;
  background: #3871e5;
  text-align: center;
  line-height: 32px;
  font-size: 14px;
  color: #fff;
  cursor: pointer;
}

.content-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
  height: 48px;
  border-bottom: 1px solid #e4e7ee;
}

.content-main {
  height: calc(100% - 102px);
  padding: 10px;
}

.search {
  text-align: left;
  margin-bottom: 10px;
}

.table {
  height: calc(100% - 43px);
}

.pagination {
  height: 50px;
  box-shadow: 6px 0px 10px 0px rgba(197, 197, 197, 0.3);
}
</style>